import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/shared/service/api.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { PoModalComponent, PoNotificationService } from '@po-ui/ng-components';
import { CONSTANTS } from 'src/app/constants';
import { ModalPersonStatisticsComponent } from '../modal-person-statistics/modal-person-statistics.component';

@Component({
  selector: 'app-birthdays-day',
  templateUrl: './birthdays-day.component.html',
  styleUrls: ['./birthdays-day.component.css']
})
export class BirthdaysDayComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }

  @Output() errorEmitter = new EventEmitter();
  @ViewChild('modalStats', { static: false }) modalStats!: ModalPersonStatisticsComponent;

  tableItens: any[] = [];
  tableItensOriginal: any[] = [];
  personStatisticsInfo: any = 0;
  limitPersonInfo: number = 0;
  openInvoiceValue: number = 0;
  personSelect: any = {};
  branchCodes: any[] = [];
  ordem: boolean = true;
  loading: boolean = false;
  ordemAscendente: boolean = true;
  errorApi: boolean = false;
  message: string = "";
  listItem: { label: string, type: number, value: number }[] = [
    { label: 'Mês atual', type: 1, value: 1 },
    { label: 'Mês anterior', type: 2, value: 2 },
    { label: 'Próximo mês', type: 3, value: 3 },
  ];
  typeSelected = 1;
  filterInicial: any = {}

  constructor(private api: ApiService, private poNotification: PoNotificationService) { }

  ngOnInit(): void {
  }

  filterItem(item: any) {
    this.filterInicial = item;
    this.loading = true;
    let excelInfo: any[] = [];
    this.tableItens = [];
    if (item.dataMin != undefined) {
      this.birthdayReturn().subscribe((data: any) => {
        data.dataRow.map((el: any) => {
          this.tableItens.push({
            "personCode": el.personCode,
            "cliente": el.personName,
            "data": this.formatDate(el.birthdayDate),
            "contato": el.phoneNumber,
          });
          excelInfo.push({ 'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Cliente': el.personName, 'Data Aniversário': el.birthdayDate, 'Contato': el.phoneNumber });
        });
        this.tableItensOriginal = this.tableItens;
        this.tableItens = [...this.tableItens].reverse();
        excelInfo.unshift({});
        localStorage.setItem('birthdays-day-sellers', JSON.stringify(excelInfo));
        this.loading = false;
        this.errorApi = false;
      },
        (error) => {
          this.loading = false;
          this.errorApi = true;
          this.message = CONSTANTS.MESSAGES.DATA_ERRO_BIRTHDAYS_DAY;
          this.formatErrorMensagem(error.message);
        });
    }
  }

  isToday(data: string): boolean {
    const hoje = new Date();
    const diaHoje = String(hoje.getDate()).padStart(2, '0');
    const mesHoje = String(hoje.getMonth() + 1).padStart(2, '0');

    const [diaExibido, mesExibido] = data.split('/');
    
    return diaExibido === diaHoje && mesExibido === mesHoje;
  }

  recoverProduct(item: any) {
    this.typeSelected = item;
    this.filterItem(this.filterInicial);
  }

  copyContact(item: any) {
    navigator.clipboard.writeText(item).then(() => {
      this.poNotification.success('contato copiado com sucesso!');
    }).catch((err: any) => {
      this.poNotification.error('Erro ao copiar o contato!');
    });
  }

  openChart(item: any) {
    this.personSelect = item;
    const filterInfoBranchs = localStorage.getItem("filterInfoBranchs");
    this.branchCodes = filterInfoBranchs ? JSON.parse(filterInfoBranchs) : this.filterInicial.branch;
    this.modalStats.open(item, this.branchCodes);
  }

  sendWa(item: any) {
    const encodedMessage = encodeURIComponent(CONSTANTS.MESSAGES.DATA_MESSAGE_WHATSAPP);
    const plusCountry = '55' + item.replace(/\D/g, '');
    const url = `https://wa.me/${plusCountry}?text=${encodedMessage}`;
    window.open(url, '_blank');
  }

  formatDate(item: any) {
    let data = item;
    let dataSplit = data.split('-');
    let dia = dataSplit[1];
    let mes = dataSplit[0];
    return dia + "/" + mes;
  }

  ordenarTabela(colunaTipo: any) {
    this.loading = true;
    if (colunaTipo === 'cliente') {
      this.tableItens = this.tableItensOriginal;
      this.tableItens.sort((a: any, b: any) => {
        if (this.ordem) return a.cliente[0].toLowerCase().localeCompare(b.cliente[0].toLowerCase())
        if (!this.ordem) return b.cliente[0].toLowerCase().localeCompare(a.cliente[0].toLowerCase())
      });

      const iconCliente = document.getElementById('icon-cliente');
      this.ordem
        ? (
          iconCliente!.classList.remove('po-icon', 'po-icon-arrow-down'),
          iconCliente!.classList.add('po-icon', 'po-icon-arrow-up')
        )
        : (
          iconCliente!.classList.remove('po-icon', 'po-icon-arrow-up'),
          iconCliente!.classList.add('po-icon', 'po-icon-arrow-down')
        )

      this.ordem = !this.ordem;
      this.loading = false;
    }
    if (colunaTipo === 'data') {
      this.tableItens.sort((a: any, b: any) => {
        const [diaA, mesA] = a.data.split('/').map(Number);
        const [diaB, mesB] = b.data.split('/').map(Number);

        const dataA = new Date(2024, mesA - 1, diaA);
        const dataB = new Date(2024, mesB - 1, diaB);

        return this.ordem ? dataA.getTime() - dataB.getTime() : dataB.getTime() - dataA.getTime();
      });

      const iconData = document.getElementById('icon-data');
      this.ordem
        ? (
          iconData!.classList.remove('po-icon', 'po-icon-arrow-down'),
          iconData!.classList.add('po-icon', 'po-icon-arrow-up')
        )
        : (
          iconData!.classList.remove('po-icon', 'po-icon-arrow-up'),
          iconData!.classList.add('po-icon', 'po-icon-arrow-down')
        )

      this.ordem = !this.ordem;
      this.loading = false;
    }
  }

  formatDateToYYYYMMDD(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
  
    return `${year}-${month}-${day}`;
  }

  birthdayReturn() {
    let today = new Date();
    let year = today.getFullYear();
    let month = today.getMonth();
    let formattedDateFirst = '';
    let formattedDateLast = '';
    
    if (this.typeSelected === 1) {
      const firstDayOfCurrentMonth = new Date(year, month, 1);
      formattedDateFirst = this.formatDateToYYYYMMDD(firstDayOfCurrentMonth);
  
      const lastDayOfCurrentMonth = new Date(year, month + 1, 0);
      formattedDateLast = this.formatDateToYYYYMMDD(lastDayOfCurrentMonth);
    }
    if (this.typeSelected === 2) {
      const firstDayOfPreviousMonth = new Date(year, month - 1, 1);
      formattedDateFirst = this.formatDateToYYYYMMDD(firstDayOfPreviousMonth);
      
      const lastDayOfPreviousMonth = new Date(year, month, 0);
      formattedDateLast = this.formatDateToYYYYMMDD(lastDayOfPreviousMonth);
    }
    if (this.typeSelected === 3) {
      const firstDayOfNextMonth = new Date(year, month + 1, 1);
      formattedDateFirst = this.formatDateToYYYYMMDD(firstDayOfNextMonth);
      
      const lastDayOfNextMonth = new Date(year, month + 2, 0);
      formattedDateLast = this.formatDateToYYYYMMDD(lastDayOfNextMonth);
    }

    return this.api.postBirthdaySellerPanel(formattedDateFirst, formattedDateLast);
  }

  personStatisticsReturn(item: any) {
    const filterInfoBranchs = localStorage.getItem("filterInfoBranchs");
    const parsedBranches = filterInfoBranchs ? JSON.parse(filterInfoBranchs) : this.filterInicial.branch;

    return this.api.getPersonStatistics(item.personCode, parsedBranches);
  }

  limitsPersonReturn(item: any) {
    const filterInfoBranchs = localStorage.getItem("filterInfoBranchs");
    const parsedBranches = filterInfoBranchs ? JSON.parse(filterInfoBranchs) : this.filterInicial.branch;

    return this.api.postCustomerFinancialBalance(item.personCode, parsedBranches);
  }

  downloadExcel() {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    let dataBirthdays = [];
    let objectBirthdays = localStorage.getItem('birthdays-day-sellers');

    objectBirthdays != null
      ? (dataBirthdays = JSON.parse(objectBirthdays))
      : (dataBirthdays = []);
    const worksheetBirthdays = XLSX.utils.json_to_sheet(dataBirthdays);

    const workbook = {
      Sheets: {
        'birthdays-day': worksheetBirthdays,
      },
      SheetNames: [
        'birthdays-day',
      ],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, 'minhas-operacoes-birthdays-day' + EXCEL_EXTENSION);
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: birthdays-day \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }

}
